import React from 'react';
import '../less';

import Career from '../views/career.c';
import VacanciesList from '../views/vacanciesList.c';
import Vacancy from '../views/vacancy.c';



export default function template() {
    let Component = null;
    const {model} = this.state;

    if (this.props.match.params.type === 'vacancies-list' && !this.props.match.params.id) {
        Component = VacanciesList;
    } else if (this.props.match.params.id) {
        Component = Vacancy;
    } else {
        Component = Career;
    }
    return (
        <div className="module-career">
            <Component {...this} model={model} {...this.props} />
        </div>
    );
}
